var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-4 py-5 my-5 text-center" },
    [
      _c("b-icon", {
        staticStyle: { width: "100px", height: "100px" },
        attrs: { icon: "exclamation-circle" },
      }),
      _vm._v(" "),
      !_vm.is_excel
        ? _c(
            "div",
            [
              _c("h1", { staticClass: "display-5 fw-bold mt-3" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("POS_NOT_ATTACHED")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 mx-auto" }, [
                _c("p", { staticClass: "lead mb-4" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("CREATE_POS_HOW")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-grid gap-2 d-sm-flex justify-content-sm-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "btn btn-primary btn-lg px-4 me-sm-3 emptystate-btnadd",
                        attrs: { id: "confirmButton" },
                        on: { click: _vm.show_settings },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.__t("CREATE_POS_SETTINGS")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.has_register
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn btn-outline-success btn-lg px-4 me-sm-3 ml-2 emptystate-btnadd",
                            on: { click: _vm.show_register },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.__t("AUTH_POS")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("user_password"),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("h1", { staticClass: "display-5 fw-bold mt-3" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("UPLOAD_FILE")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("fileload", {
                attrs: {
                  doc_id: _vm.cur_provider_id,
                  doc_type: "feed",
                  url_load: "pos/upload/feed",
                },
                on: { finish_load: _vm.finish_load },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }